<template>
  <div class="prism-player" :id="playerId"></div>
</template>
<script>
export default {
  props: {
    path: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      playerId: `aliplayer_${new Date().getTime().toString(36)}${Math.random()
        .toString(36)
        .substring(2)}`
    };
  },
  mounted() {
    let player = new Aliplayer(
      {
        id: this.playerId,
        width: "100%",
        autoplay: true,
        source: this.path,
        isLive: false,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true
      },
      player => {
        console.log("Player Loading Finished...");
      }
    );
  }
};
</script>
<style scoped>
@ipmort 'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css';
</style>